<template>
  <div class="pad">
    <pad-frame
      :class="'hidkey_' + hotel.id"
      :thumbnail_url="hotel.thumbnail_url"
      :image_link="detail_custom_link"
      :wrap_class="amenities_flags.length ? '' : 'pad__wrap--20'"
    >
      <pad-heading
        :hotel="hotel"
        :link="detail_custom_link"
        @toggle-map="$emit('toggle-map')"
      />
      <div class="pad__row pad__row--second">
        <div class="pad__room">
          <rate-promotions
            :promos="hotel.room.rate.promotions"
            :show="'value_adds'"
          />
          <p class="pad__room-title">{{ hotel.room.name }}</p>
          <rate-info
            class="pad__room-info"
            :rate="hotel.room.rate"
          />
        </div>
        <div class="pad__price">
          <rate-promotions
            :promos="hotel.room.rate.promotions"
          />
          <rate-amount
            :prices="hotel.room.rate.pricing"
          />
          <custom-link v-bind="detail_custom_link">
            <template #content>
              <vb-button
                class="pad__cta shadow"
                :vb_options="{
                  text: 'Vedi disponibilità',
                  variant: 'info',
                  size: 'sm'
                }"
              />
            </template>
          </custom-link>
        </div>
      </div>
      <div class="pad__push" v-if="amenities_flags.length">
        <template v-for="(amenity, amenity_index) in amenities_flags">
          <div
            class="pad__push-btn"
            v-if="amenity_index < 2"
            :key="_uid+'amenities'+amenity+amenity_index"
          >
            <amenity
              v-b-popover.hover.top="get_amenities_flags(amenity).label"
              :item="amenity"
              :type="'flags'"
            />
          </div>
        </template>
        <div
          class="pad__push-btn"
          v-b-modal="_uid+'modal_amenities'"
          v-if="amenities_flags.length > 2"
        >
          <vb-icon
            class="pad__push-icon"
            :name="'dotted'"
            :color="sass('black')"
            :size="16"
          />
        </div>
        <vb-modal
          :vb_options="{
            id: _uid+'modal_amenities',
            body_class: 'pad__modal',
            title: 'Principali Servizi',
            size: 'md',
            centered: true,
            hide_footer: true
          }"
        >
          <div class="pad__modal-wrap">
            <template v-for="(amenity, amenity_index) in amenities_flags">
              <div class="pad__modal-item" v-if="amenity" :key="_uid+'amenities'+amenity_index">
                <amenity
                  :item="amenity"
                  :type="'flags'"
                />
              </div>
            </template>
          </div>
        </vb-modal>
      </div>
    </pad-frame>
  </div>
</template>

<script>
import { get_amenities_flags } from '@liveeps/resources'
import PadFrame from "@liveeps/components/blocks/pad-frame.vue"
import PadHeading from "@liveeps/components/blocks/pad-heading.vue"
import Amenity from "@liveeps/components/atoms/amenity"
import RateInfo from "@liveeps/components/atoms/rate-info"
import RateAmount from "@liveeps/components/blocks/rate-amount"
import RatePromotions from "@liveeps/components/blocks/rate-promotions"

export default {
  name: "pad",

  components: {
    'pad-frame': PadFrame,
    'pad-heading': PadHeading,
    'amenity': Amenity,
    'rate-info': RateInfo,
    'rate-amount': RateAmount,
    'rate-promotions': RatePromotions,
  },

  props: {
    hotel: Object,
  },

  provide() {
    return {
      prices: () => this.hotel.room.rate.pricing // injection per rate-deal
    }
  },

  computed: {
    amenities_flags() {
      const { amenities_flags } = this.hotel
      return Object.keys(amenities_flags).filter(key => amenities_flags[key])
    },

    detail_custom_link() {
      return {
        before_navigation: () => {
          this.$store.commit('liveeps/update_selected_property', this.hotel)
        },
        route_name: 'detail',
        css_class: 'd-block h-100',
        as_default: this.get_config('guiSettings.openDetailNewTab', false),
      }
    },
  },

  created() {
    this.get_amenities_flags = get_amenities_flags
  },

  watch: {},

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  %deco_circle {  //todo : spostare in utilities sass
    &:after {
      content: '';
      width: 4px;
      height: 4px;
      display: inline-block;
      border-radius: $border-radius;
      background-color: $gray-600;
      margin-left: $grid-gutter-width/5;
    }

    &:last-child {
      margin-right: 0;

      &:after {
        display: none;
      }
    }
  }

  .pad {
    $this: &;
    position: relative;

    &__row {
      display: flex;
      flex-direction: column;

      @include media-breakpoint-up(md){
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      &--second {
        align-items: flex-start;
        margin-top: $grid-gutter-width / 2;
        order: 2;
      }
    }

    &__room {
      padding-left: $grid-gutter-width/3;
      border-left: 1px solid $gray-300;

      @include media-breakpoint-up(lg){
        flex-basis: 70%;
      }

      &-title {
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
        background-color: $gray-200;
        color: $gray-600;
        padding: 0 5px;
        border-radius: 5px;
        margin-bottom: 0;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 250px;

        @include media-breakpoint-up(lg){
          max-width: 350px;
        }
      }

      &-info {
        border: none;
        padding-left: 0;
      }
    }

    &__price {
      line-height: normal;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      width: 100%;
      margin-top: $grid-gutter-width / 2;
      position: relative;

      @include media-breakpoint-up(md) {
        text-align: right;
        flex-basis: 40%;
        display: block;
        margin-top: -$grid-gutter-width / 3;
      }
    }

    &__cta {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-md;
      margin-top: $grid-gutter-width / 4;
    }

    &__push {
      display: flex;
      align-items: center;
      padding: $grid-gutter-width / 3 0;

      @include media-breakpoint-up(lg) {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: var(--primary);
        padding: 0 7px;
        margin-top: 0;
        flex-direction: column;
        justify-content: center;
        border-radius: $border-radius-lg * 2;
        overflow: hidden;
      }

      &-btn {
        background-color: var(--primary);
        border-radius: $rounded-pill;
        padding: 10px;
        margin-right: 10px;

        @include media-breakpoint-up(lg) {
          background-color: transparent;
          border-radius: 0;
          padding: 10px 0 0;
          margin-right: 0;
          margin-top: 10px;
          border-top: 1px solid rgba(255,255,255, .20);
        }

        &:first-child {
          @include media-breakpoint-up(lg) {
            margin-top: 0;
            padding-top: 0;
            border-top: 0;
          }
        }

        &:last-child {
          margin-right: 0;
        }

        ::v-deep {
          // cambio colore icona desktop
          svg * {
            fill: $white;
          }

          .amenity {

            &__icon {
              margin: 0;
            }
            &__text {
              display: none;
            }
          }
        }
      }
    }

    &__modal {

      &-wrap {
        display: flex;
        flex-wrap: wrap;
      }

      &-item {
        display: flex;
        align-items: center;
        flex-basis: 33.333%;
        margin: $grid-gutter-width / 6 0;

        &_icon {
          margin-right: 5px;
        }
      }
    }
  }

</style>